import api from '../apiConnector'
import FormPage from './formPage';
import FieldSelect from './fields/fieldSelect';
import FieldText from './fields/fieldText';
import FieldDate from './fields/fieldDate';
import FieldYesNo from './fields/fieldYesNo';
import FieldNumeric from './fields/fieldNumeric';
import LegalDetails from './legalDetails';

export default class FrontVous extends FormPage {
    constructor(props) {
        super(props);
        this.title = 'Vous'
        this.state = {
            showValidate:false,
            cities:[],
            cp:''
        }
    }


    next() {
        this.props.setPage('antecedents')
    }

    back() {
        this.props.setPage('vehicule')
    }

    componentDidMount() {
        this.updateCities()
    }

    componentDidUpdate( prevProps, prevState ) {
        if ( this.props.devis.params.code_postal != prevProps.devis.params.code_postal ) {
            this.updateCities()
        }
    }

    updateCities() {
        const code_postal = this.props.devis.params.code_postal
        const me = this
        if ( code_postal ) {
            api.post(
                {
                    action:'resolve_cp',
                    cp:code_postal
                },
                (res)=>{
                    if ( me.props.devis.params.code_postal == res.cp ) {
                        this.setState({
                            cities:res.cities.map( city => ({ value:city, label:city }) ),
                            cp: res.cp
                        })
                    }
                }
            )
        } else {
            this.setState({cities:[],cp:code_postal})
        }
    }

    parseDate(dateStr) {
        if ( !dateStr ) return undefined
        const [day, month, year] = dateStr.split('/');
        // Note: Month is 0-indexed (January is 0)
        return new Date(year, month - 1, day);
    }


    doRender(container) {
        const {type} = this.props
        const params = this.props.devis.params

        const nonAssureRelevance = ( this.parseDate( params.date_acquisition ) < this.parseDate( params.date_effet ) )
        const nonAssure = ( params.hamon_deja_assure != 'O' )&& nonAssureRelevance

        return <>
            <div className="contentvbox">
            <h1 className="top_title">Vous</h1>
            <FieldDate field="date_naissance" container={container}/>
            <FieldSelect field="situation_famille" container={container} />
            {type=='moto'?<></>:
                <FieldSelect field="csp" container={container} />
            }
            <FieldNumeric field="nombre_enfants" container={container}  min="0" max="16" />
            <FieldSelect field="civilite" container={container} />
            <FieldText field="nom" container={container}/>
            <FieldText field="prenom" container={container}/>
            <FieldText field="chez" container={container}/>
            <FieldText field="adresse2" container={container}/>
            <FieldText field="adresse" container={container}/>
            <FieldText 
                field="code_postal" 
                container={container}
                onValidate={ value => ( this.state.cp == value ) ? false : 'Le code postal et la ville sont en cours de vérification. Merci de patienter quelques secondes , ou rechargez la page.' }
                />
            <FieldSelect 
                field="ville" 
                container={container} 
                options={this.state.cities}
                onValidate={ 
                    value => {
                        return this.state.cities.some( entry => entry.value == value ) ? false : 'La ville ne correspond pas au code postal' 
                    }
                }
            />
            <FieldText field="telephone" container={container}/>
            <FieldText field="email" container={container}/>

            <FieldText field="commune_naissance" label="Commune de naissance (France uniquement)" container={container} />
            <i>Sans code postal. Exemple: Paris</i>
            <FieldSelect field="pays_naissance" label="ou pays de naissance" container={container}/>

            {type=='moto'?<>
                <FieldSelect field="norme_permis" container={container}  />
                <FieldSelect field="categorie_permis" container={container}  />
                <FieldDate field="date_obtention_permis" container={container}  />
                <LegalDetails container={container} />
                <FieldYesNo field="assure_actuellement" container={container} />
                
                <FieldNumeric field="nb_mois_moto" container={container} min={0} max={24} />
                <FieldNumeric field="nb_mois_auto" container={container} min={0} max={24} />

                <FieldText field="coefficient_auto" container={container}/>
                <i>Entre 50 (bonus maximal) et 350 (malus maximal)</i>
                <FieldText field="coefficient_moto" container={container}/>
                <i>Entre 50 (bonus maximal) et 350 (malus maximal)</i>
                { (( parseInt(params.coefficient_moto) <= 50 )||( parseInt(params.coefficient_auto) <= 50 ))
                ? <FieldYesNo field="bonus_50_plus_3_ans" container={container} />
                : '' }
                <FieldYesNo field="assure_12_sur_36" container={container} />
            </>:<>
                <FieldSelect field="norme_permis" container={container}  />
                <FieldDate field="date_obtention_permis" container={container} label="Date d'obtention du permis B" />
                <FieldYesNo field="cac" container={container}  />
                <FieldYesNo field="assure_actuellement" container={container} label="Vous êtes assuré actuellement pour une auto"/>
                {(params.assure_actuellement=='O')?<>
                    <FieldSelect field="antecedant_assur" container={container}  />
                </>:<>
                    <FieldSelect field="antecedant_non_assur" container={container}  />
                </>}
                <FieldText field="coefficient_auto" container={container}/>
                <i>Entre 50 (bonus maximal) et 350 (malus maximal)</i>
                { ( parseInt(params.coefficient_auto) <= 50 )
                ? <FieldYesNo field="bonus_50_plus_3_ans" container={container} />
                : '' }

                    <FieldYesNo field="conducteur_2" container={container} />
                    <i>Seuls les conjoints et concubins sont élligibles comme conducteur secondaire sur ce produit.</i>
                    {(params.conducteur_2!='O')?<></>:<>
                        <FieldSelect field="parente_2" container={container}  />
                        <FieldSelect field="civilite_2" container={container}  />
                        <FieldText field="nom_2" container={container}/>
                        <FieldText field="prenom_2" container={container}/>
                        <FieldDate field="date_naissance_2" container={container} />
                        <FieldDate field="date_obtention_permis_2" container={container} />
                    </>}


                </>}

                <FieldDate field="date_effet" container={container} />
                { nonAssureRelevance && <FieldYesNo field="hamon_deja_assure" container={container} /> }

                { nonAssure && <FieldDate field="date_assure_precedement" container={container} /> }
                

            </div>

            
        </>
    }
}
